import { render, staticRenderFns } from "./withdraws.vue?vue&type=template&id=29ae6564&scoped=true&"
import script from "./withdraws.vue?vue&type=script&lang=js&"
export * from "./withdraws.vue?vue&type=script&lang=js&"
import style0 from "./withdraws.vue?vue&type=style&index=0&id=29ae6564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ae6564",
  null
  
)

export default component.exports